import { inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

export const apiInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);

  return next(request).pipe(
    finalize(() => {
      // Hide loading indicator
    }),
    catchError((error: HttpErrorResponse) => {
      // Skip logging for customer guard check
      const isCustomerCheck = request.url.includes('/customers/me');

      // Handle 401/403 errors - redirect to registration if customer not linked
      if (error.status === 401 || error.status === 403) {
        // Don't redirect if already on registration or auth pages
        const currentUrl = router.url;
        if (!currentUrl.includes('/registration') &&
            !currentUrl.includes('/callback') &&
            !currentUrl.includes('/unauthorized')) {
          router.navigate(['/registration']);
        }
        return throwError(() => error);
      }

      // Log other errors
      if (!isCustomerCheck) {
        console.error('HTTP Error:', error);
      }

      return throwError(() => error);
    })
  );
};
